export const snakeCaseToCamelCase = (s: string) =>
  s.replace(/(_\w)/g, (k) => k[1].toUpperCase());
